import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const FIND_ORGANIZATIONS_BY_ACCOUNT_MANAGER_ID_KEY = 'FIND_ORGANIZATIONS_BY_ACCOUNT_MANAGER_ID_KEY';

interface OrganizationByAccountManagerIdPayload {
  id?: number;
  name?: string;
  path?: string;
}

interface OrganizationByAccountManagerId {
  id?: string;
  name?: string;
  path?: string;
}

export const useOrganizationsByAccountManagerIdQuery = (accountManagerId?: string) => {
  const { isLoading, isSuccess, isError, data } = useQuery<{
    data: OrganizationByAccountManagerIdPayload[] | undefined;
  }>(
    [FIND_ORGANIZATIONS_BY_ACCOUNT_MANAGER_ID_KEY, accountManagerId],
    () => api.get(API_URL.ORGANIZATIONS_ACCOUNT_MANAGER_BY_ACCOUNT_MANAGER_ID(accountManagerId || '')),
    {
      enabled: Boolean(accountManagerId),
    }
  );

  const formattedData = useMemo<OrganizationByAccountManagerId[]>(
    () =>
      data?.data?.map((item) => ({
        ...item,
        id: toString(item?.id),
      })) || [],
    [data]
  );
  const names = useMemo(
    () => formattedData?.map((item) => item?.name || '')?.filter(Boolean),
    [formattedData]
  );

  return {
    isLoading,
    isSuccess,
    isError,
    formattedData,
    names,
  };
};
